import React from 'react';

import SiteContentView from './SiteContainerView';

function SiteContainer(props) {
  return <SiteContentView {...props} />;
}

export default SiteContainer;
